import React, { ComponentType, FC } from 'react';

type UseViewModel<TInput, TOutput> = (input: TInput) => TOutput;

export const withViewModel =
  <TProps extends {}, TVMInput extends {}, TVMOutput extends Partial<TProps>>(
    Component: ComponentType<TProps>,
    useViewModel: UseViewModel<TVMInput, TVMOutput>
  ): FC<TVMInput & Omit<TProps, keyof TVMOutput>> =>
  (props) => {
    const vm = useViewModel(props);
    const componentProps = { ...props, ...vm } as unknown as TProps;
    return <Component {...componentProps} />;
  };

// TODO: Uncomment new version and fix ts errors;
// import type { ComponentType, FC } from 'react';
// type UseViewModel<TInput, TOutput> = (input: TInput) => TOutput;
// type CommonProps<TComponentProps, TVMOutput> = keyof TComponentProps & keyof TVMOutput;
// type StrictPropsPartial<TComponentProps, TVMOutput> = {
//   [Key in CommonProps<TComponentProps, TVMOutput>]: TComponentProps[Key];
// };

// export const withViewModel = <
//   TComponentProps extends {},
//   TVMInput extends {},
//   TVMOutput extends StrictPropsPartial<TComponentProps, TVMOutput>
// >(
//   Component: ComponentType<TComponentProps>,
//   useViewModel: UseViewModel<TVMInput, TVMOutput>
// ): FC<TVMInput & Omit<TComponentProps, keyof TVMOutput>> =>
//   function Comp(props) {
//     const vm = useViewModel(props);
//     const componentProps = { ...props, ...vm } as unknown as TComponentProps;
//     return <Component {...componentProps} />;
//   };
